import React from "react";
import DataGrid from "../../../components/app/grid/DataGrid";
import { IRequestType } from "../../../../model/request/RequestType";
import { Form } from "antd";
import UpdateApplicantRequestForm, {
  UpdateApplicantRequestFormProps
} from "./UpdateApplicantRequestForm";
import { TRequestPresentationModel } from "../../../../presenter/request/model/RequestPresentationModel";
import { TApplicantReportingPeriodPresentationModel } from "../../../../presenter/applicants/model/ApplicantReportingPeriodPresentationModel";
import TickBox from "../../../components/app/grid/TickBox";
import CreateApplicantRequestForm, {
  CreateApplicantRequestFormProps
} from "./CreateApplicantRequestForm";
import { IApplicantReportingPeriod } from "../../../../model/applicant/ApplicantReportingPeriod";

export interface Props {
  items: TRequestPresentationModel[];
  translate: any;
  reportingPeriods: TApplicantReportingPeriodPresentationModel[];
  requestTypes: IRequestType[];
  updateRequest: any;
  createRequest: any;
  expandedReportingPeriod?: IApplicantReportingPeriod;
}

export interface State {}

export default class ApplicantRequestsGrid extends React.Component<
  Props,
  State
> {
  constructor(props) {
    super(props);
    this.state = {
      items: []
    };
  }

  render() {
    const {
      items,
      translate,
      reportingPeriods,
      requestTypes,
      updateRequest,
      expandedReportingPeriod,
      createRequest
    } = this.props;
    const UpdateForm = Form.create<UpdateApplicantRequestFormProps>({})(
      UpdateApplicantRequestForm
    );
    const CreateForm = Form.create<CreateApplicantRequestFormProps>({})(
      CreateApplicantRequestForm
    );
    const columns = [
      {
        title: translate("applicantRequest_page.name"),
        dataIndex: "name",
        key: "name"
      },
      {
        title: translate("applicantRequest_page.priority"),
        dataIndex: "priority",
        key: "priority"
      },
      {
        title: translate("applicantRequest_page.validFrom"),
        dataIndex: "validFrom",
        key: "validFrom",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.validFrom, b.validFrom)
      },
      {
        title: translate("applicantRequest_page.validTo"),
        dataIndex: "validTo",
        key: "validTo",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.validTo, b.validTo)
      },
      {
        title: translate("applicantRequest_page.read"),
        key: "read",
        render: (text, record) => <TickBox value={record.read} />,
        width: "9%"
      },
      {
        title: translate("applicantRequest_page.valid"),
        key: "valid",
        render: (text, record) => <TickBox value={record.valid} />,
        width: "7%"
      }
    ];
    let codebooks = [reportingPeriods, requestTypes, expandedReportingPeriod];
    return (
      <DataGrid
        translate={translate}
        columns={columns}
        dataSource={items}
        codebooks={codebooks}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        onCreate={createRequest}
        createForm={CreateForm}
        onUpdate={updateRequest}
        updateForm={UpdateForm}
        createModalTitle={translate("applicantRequest_page.insert_modal_title")}
        updateModalTitle={translate("applicantRequest_page.update_modal_title")}
        addButtonText={translate("applicantRequest_page.add_button_text")}
        horizontalScroll={false}
      />
    );
  }
}
